function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled, { css } from "styled-components";
import mq from "../utils/mediaQuery";
import Text from "../Text";
import { StyledButtonLink } from "../ButtonLink";
import { TOKENS, TYPES as BUTTON_TYPES } from "../ButtonLink/consts";
import getTypeToken from "../ButtonLink/helpers/getTypeToken";
import defaultTheme from "../defaultTheme";
import { rtlSpacing, right } from "../utils/rtl";
import TYPES from "./consts";
import NavigationListSeparator, { StyledNavigationListSeparator } from "./components/NavigationListSeparator";
import { isNavigation, isInline } from "./helpers/isType";
var StyledNavigationListContent = styled(function (_ref) {
  var type = _ref.type,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["type", "theme"]);

  return React.createElement("ul", props);
}).withConfig({
  displayName: "NavigationList__StyledNavigationListContent",
  componentId: "riks1e-0"
})(["display:flex;width:100%;flex-direction:", ";list-style:none;padding:0;", ";", ";"], function (_ref4) {
  var type = _ref4.type;
  return isNavigation(type) ? "column" : "row";
}, function (_ref5) {
  var type = _ref5.type;
  return isInline(type) && css(["", "{padding:0 ", ";:hover{color:", "!important;}}"], StyledButtonLink, function (_ref6) {
    var theme = _ref6.theme;
    return theme.orbit.spaceXSmall;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return getTypeToken(TOKENS.colorTextButtonHover)({
      theme: theme,
      type: BUTTON_TYPES.PRIMARY
    });
  });
}, function (_ref8) {
  var type = _ref8.type;
  return isNavigation(type) ? css(["margin:", ";"], function (_ref9) {
    var theme = _ref9.theme;
    return rtlSpacing("0 0 ".concat(theme.orbit.spaceLarge, " 0"));
  }) : css(["margin:0;"]);
});
StyledNavigationListContent.defaultProps = {
  theme: defaultTheme
};
var StyledNavigationList = styled(function (_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type,
      props = _objectWithoutProperties(_ref2, ["theme", "type"]);

  return React.createElement("div", props);
}).withConfig({
  displayName: "NavigationList__StyledNavigationList",
  componentId: "riks1e-1"
})(["display:flex;flex-direction:column;width:100%;", ";"], function (_ref10) {
  var type = _ref10.type;
  return isNavigation(type) ? css(["padding:", ";:last-child{padding-bottom:0;", "{display:none;}", "{margin:0;}}"], function (_ref11) {
    var theme = _ref11.theme;
    return rtlSpacing("0 0 ".concat(theme.orbit.spaceLarge, " 0"));
  }, StyledNavigationListSeparator, StyledNavigationListContent) : css(["> *{margin-", ":4px;}"], right);
});
StyledNavigationList.defaultProps = {
  theme: defaultTheme
};
var StyledNavigationListTitle = styled.div.withConfig({
  displayName: "NavigationList__StyledNavigationListTitle",
  componentId: "riks1e-2"
})(["padding:0 ", ";", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.orbit.spaceMedium;
}, mq.largeMobile(css(["padding:0 ", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.orbit.spaceXLarge;
})));
StyledNavigationListTitle.defaultProps = {
  theme: defaultTheme
};
var StyledNavigationListChild = styled(function (_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type,
      props = _objectWithoutProperties(_ref3, ["theme", "type"]);

  return React.createElement("li", props);
}).withConfig({
  displayName: "NavigationList__StyledNavigationListChild",
  componentId: "riks1e-3"
})(["", ";"], function (_ref14) {
  var type = _ref14.type;
  return isInline(type) && css(["margin-", ":4px;:last-child{margin:0;}"], right);
});

var NavigationList = function NavigationList(_ref15) {
  var children = _ref15.children,
      title = _ref15.title,
      dataTest = _ref15.dataTest,
      _ref15$type = _ref15.type,
      type = _ref15$type === void 0 ? TYPES.NAVIGATION : _ref15$type;
  return React.createElement(StyledNavigationList, {
    "data-test": dataTest,
    type: type
  }, title && React.createElement(StyledNavigationListTitle, null, React.createElement(Text, {
    type: "secondary",
    weight: "bold",
    uppercase: true,
    size: "small",
    spaceAfter: "normal"
  }, title)), React.createElement(StyledNavigationListContent, {
    type: type
  }, React.Children.map(children, function (item) {
    return React.createElement(StyledNavigationListChild, {
      type: type
    }, React.isValidElement(item) ? React.cloneElement(item) : item);
  })), isNavigation(type) && React.createElement(NavigationListSeparator, null));
};

export default NavigationList;
export { default as NavigationListItem } from "./NavigationListItem";